export const RULE_FIELD_MAP = {
  name: ['first_name', 'last_name', 'name'],
  email: ['username','personal_email', 'email'],
  phone: ['personal_phone', 'phone'],
  passport: ['passport_number'],
  visa: ['visa_number'],
  
};
